import { convertCondition } from './SituationBuilderUtils';

export function transform(obj) {
  if (Array.isArray(obj)) return obj.map((item) => transform(item));
  if (obj && typeof obj === 'object') {
    const ks = Object.keys(obj);
    if (ks.length === 1) {
      const op = ks[0];
      const arr = obj[op];
      if (Array.isArray(arr) && arr.length >= 2) {
        const first = arr[0];
        const second = arr[1];
        if (first && typeof first === 'object' && first.var !== undefined) {
          const operator = first.var;
          const comp = transform(second);
          return { [operator]: [{ var: 'acc' }, { op, comp }] };
        }
      }
    }
    const newObj = {};
    for (let k in obj) newObj[k] = transform(obj[k]);
    return newObj;
  }
  return obj;
}

function removePrefixesInCondition(inputString: string) {
  return inputString
    .replace(/numerics./g, '')
    .replace(/customNumerics./g, '')
    .replace(/candidate_triggers./g, '')
    .replace(/triggers./g, '')
    .replace(/variables./g, '')
    .replace(/formulae./g, '');
}

export function formatCondition(condition: string | undefined) {
  if (!condition) return null;

  let formatted = condition.replace(/"/g, '').replace(/\\/g, '').replace(/NOT/g, '!');

  formatted = removePrefixesInCondition(formatted);
  let index = formatted.indexOf('IN');

  while (index !== -1) {
    formatted = convertCondition(formatted, index);
    index = formatted.indexOf('IN');
  }

  return formatted;
}
